import { render, staticRenderFns } from "./fiat_deposit.vue?vue&type=template&id=d9884e08&scoped=true"
import script from "./fiat_deposit.vue?vue&type=script&lang=js"
export * from "./fiat_deposit.vue?vue&type=script&lang=js"
import style0 from "./fiat_deposit.vue?vue&type=style&index=0&id=d9884e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9884e08",
  null
  
)

export default component.exports